import React from "react";
import { useNavigate } from "react-router-dom";
import "./Footer.css";

const SOCIAL_LINKS = [
  { id: "instagram", label: "Instagram", icon: "pi pi-instagram", href: "https://www.instagram.com/angelvarius.shop/" },
  { id: "facebook",  label: "Facebook",  icon: "pi pi-facebook",  href: "https://www.facebook.com/angelvarius.shop.fb/" },
  { id: "tiktok",    label: "TikTok",    icon: "pi pi-tiktok",    href: "https://tiktok.com/@angelvariusshop" },
  { id: "X",           label: "X",          icon: "pi pi-twitter",    href: "https://x.com/AngelvariusShop" },
  { id: "youtube",    label: "YouTube",    icon: "pi pi-youtube",    href: "https://www.youtube.com/@AngelvariusShop" },
  { id: "whatsapp",  label: "WhatsApp",  icon: "pi pi-whatsapp",  href: "https://wa.me/message/CJH5F4NQS6PNN1" },
];

const NAV_COLS = [
  {
    id: "tienda",
    heading: "Tienda",
    links: [
      { label: "Catálogo",   href: "/shop" },
      { label: "Novedades",  href: "/shop?novelty=true" },
      { label: "Pre-orders", href: "/shop?preorder=preorder" },
      { label: "Ofertas",    href: "/shop?sales=true" },
    ],
  },
  {
    id: "lineas",
    heading: "Líneas",
    links: [
      { label: "S.H.Figuarts", href: "/shop/?category=s.h.figuarts" },
      { label: "Nendoroid",    href: "/shop/?category=nendoroid" },
      { label: "Figma",        href: "/shop/?category=figma" },
    ],
  },
  {
    id: "info",
    heading: "Información",
    links: [
      { label: "Sobre nosotros", href: "/about" },
      { label: "Cotizaciones",   href: "/contact" },
      { label: "Envíos",         href: "/shipping" },
      { label: "Contacto",       href: "/contact" },
    ],
  },
];

const Footer = () => {
  const navigate = useNavigate();
  const year = new Date().getFullYear();

  const handleNav = (href) => {
    // Si el link tiene parámetros de búsqueda (?), scroll al inicio
    if (href.startsWith("http")) {
      window.open(href, "_blank", "noopener noreferrer");
    } else {
      navigate(href);
      window.scrollTo(0, 0); // Importante: volver arriba al cambiar de página
    }
  };

  return (
    <footer className="site-footer">
      <div className="footer-body">
        {/* Columna Marca */}
        <div className="footer-brand">
          <p className="footer-logo">Angel<span>varius</span></p>
          <p className="footer-tagline">
            Figuras y coleccionables importados de Japón — 100% originales,
            nuevos y sellados.
          </p>
          <div className="footer-social">
            {SOCIAL_LINKS.map((s) => (
              <a
                key={s.id}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social__btn"
                aria-label={s.label}
              >
                <i className={s.icon} />
              </a>
            ))}
          </div>
        </div>

        {/* Columnas Navegación */}
        {NAV_COLS.map((col) => (
          <div key={col.id} className="footer-nav-col">
            <p className="footer-nav-col__heading">{col.heading}</p>
            <ul className="footer-nav-col__list">
              {col.links.map((link) => (
                <li key={link.label}>
                  <button
                    className="footer-nav-col__link"
                    onClick={() => handleNav(link.href)}
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="footer-bar">
        <p className="footer-bar__copy">
          &copy; {year} Angelvarius — Todos los derechos reservados
        </p>
        <p className="footer-bar__note">
          Sitio en desarrollo — las compras en línea no están habilitadas aún
        </p>
      </div>
    </footer>
  );
};

export default Footer;